import React, { memo } from 'react';

import { NESTED_MENU_ITEM_PADDING } from '../../../constants';
import { MenuContentItem as MenuContentItemComponent } from './MenuContentItem';
import { MenuSplitItem } from './MenuSplitItem';
import { isSectionMenuContentItem, MenuContentItem, SectionMenuContentItem } from '@ael/core-api';
import { List } from 'immutable';
import AnimateHeight from 'react-animate-height';

import './MenuContentWrapper.scss';

export interface MenuContentWrapperProps {
  contentItems: List<MenuContentItem>;
  active?: boolean;
  isGrandChild?: boolean;
  nestedLevel?: number;
  onContentItemClick?: (contentItemId: string) => void;
}

export const MenuContentWrapper: React.FunctionComponent<MenuContentWrapperProps> = memo(
  ({ contentItems, active, isGrandChild, nestedLevel = 0, onContentItemClick }) => {
    const regularContentItems = React.useMemo(() => {
      return contentItems.filter((item: MenuContentItem) => !isSectionMenuContentItem(item)).toList();
    }, [contentItems]);

    const sections = React.useMemo(() => {
      return contentItems
        .filter((item: MenuContentItem | SectionMenuContentItem) => isSectionMenuContentItem(item))
        .toList() as List<SectionMenuContentItem>;
    }, [contentItems]);

    return (
      <AnimateHeight
        height={active ? 'auto' : 0}
        duration={500}
        className="menu-content-wrapper"
        style={{ paddingLeft: nestedLevel * NESTED_MENU_ITEM_PADDING }}
      >
        {regularContentItems.map((item: MenuContentItem) => (
          <MenuContentItemComponent
            key={item.itemId}
            item={item}
            onClick={onContentItemClick ? () => onContentItemClick(item.itemId) : undefined}
            isGrandChild={isGrandChild}
          />
        ))}
        {sections && sections.size > 0 && <MenuSplitItem sections={sections} onClick={onContentItemClick} />}
      </AnimateHeight>
    );
  }
);
